export default "__VITE_ASSET__C0nnA_dT__"